<!--
 @description view 设置页
 @author xiehan
 @date 2018/12/18
-->
<template>
  <div>
    <g-back :history="history"></g-back>
    <div style="display: flex;">
      <div class="card-wrap ilb">
        <el-card shadow="always" :body-style="cardStyle">
          <el-row :gutter="10">
            <el-col :span="13">
              <el-form  ref="titleForm" :model="titleForm" :rules="titleRules">
                <el-form-item prop="viewTitle">
                  <el-input v-model="titleForm.viewTitle" :placeholder="$t('view.nameTips')"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="11">
              <el-button type="primary" @click="saveView" v-text="$t('common.save')" v-g-rac="gRac('viewEdit_save')"></el-button>
              <el-button type="primary" @click="run" v-text="$t('view.run')"></el-button>
            </el-col>
          </el-row>
          <div class="view-config--form-title" v-text="$t('view.xConfig')"></div>
          <el-form label-width="60px" input-width="auto">
            <el-form-item :label="'Name:'">
              <el-input v-model="xName"></el-input>
            </el-form-item>
            <el-form-item :label="'Field:'">
              <g-select v-model="xField" :list="select_field"></g-select>
            </el-form-item>
          </el-form>
          <div v-for="(item, index) in yConfigList" :key="'yConfig' + index" style="position: relative;">
            <div class="view-config--form-title" v-text="$t('view.yConfig')"></div>
            <i v-show="yConfigList.length > 1" class="uk-icon-circle-close view-config--form__close" @click="deleteYfield(index)"></i>
            <el-form label-width="60px" input-width="auto">
              <el-form-item :label="'Name:'">
                <el-input v-model="item.name"></el-input>
              </el-form-item>
              <el-form-item :label="'Field:'">
                <g-select v-model="item.field" :list="select_field"></g-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="view-config--form-title" v-text="'Series'" v-show="isSeries"></div>
          <el-form label-width="60px" input-width="auto"  v-show="isSeries">
            <el-form-item :label="'Field:'">
              <g-select v-model="series" :list="select_field" @change="changeSeries"></g-select>
            </el-form-item>
          </el-form>
          <div style="text-align: center;">
            <el-button type="primary" @click="addYfield" v-text="$t('view.addYfield')" v-show="!isSeries"></el-button>
            <el-button type="primary" @click="addSeries" v-text="seriesBtnText"></el-button>
          </div>
        </el-card>
      </div>
      <div class="chart-wrap ilb">
        <div class="ip-wrap">
          <div class="ilb" v-for="(item, index) in legendList" :key="'IP' + index">
            <div class="color-wrap">
              <el-color-picker v-model="item.color" size="mini" @change="changeColor(item, index)"></el-color-picker>
              <span v-text="item.text"></span>
            </div>
          </div>
        </div>
        <div id="viewChart" :style="chartStyle"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import chartBase from '@/components/chart/chart-base.vue'

  import echarts from 'echarts'
  import ViewBiz from '@/logic/intelligentMonitor/viewBiz'
  import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
  import FilterData from '@/logic/intelligentMonitor/viewDataHelper'
  import rac from '@/plugins/rac-mixin'
  import TimeFormat from '@/utils/timeFormat'
  import EventCenter from '@/utils/eventCenter'
  const eventCenter = EventCenter()
  const filterData = new FilterData()

  let seriesColor = [
    '#0B8DE5',
    '#43CD80',
    '#40E0D0',
    '#FFEC8B',
    '#FFA07A',
    '#FF69B4',
    '#FF0000',
    '#CDC9C9',
    '#DEB887',
    '#AB82FF',
    '#B8860B',
    '#87CEEB',
    '#8FBC8F',
    '#B4EEB4',
    '#CD5B45',
    '#F08080'
  ]

  const CHART_OPTION = {
    color: seriesColor,
    tooltip: {
      trigger: 'axis'
    },
    title: {
      text: '',
      left: '2%'
    },
    grid: {
      left: '4%',
      right: '6%',
      top: '18%',
      bottom: '6%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      nameLocation: 'center',
      nameGap: 48,
      data: [],
      axisLine: {
        lineStyle: {
          color: '#d8d8d8'
        }
      },
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        color: '#7c7c7c',
        formatter: function (value) {
          if (value.indexOf(' ') > -1) {
            let splitArr = value.split(' ')
            let str = splitArr[0] + '\n' + splitArr[1]
            return str
          }
          return value
        }
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      max: null,
      // splitNumber: 5,
      axisLabel: {
        color: '#7c7c7c'
      },
      splitLine: {
        lineStyle: {
          color: '#d8d8d8'
        }
      }
    },
    series: []
  }
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        cardStyle: {
          background: '#F3F3F3',
          border: '1px solid #ddd',
          padding: '10px',
          height: '556px',
          overflow: 'auto'
        },
        chartStyle: {
          width: '600px',
          height: '400px'
        },
        titleForm: {
          viewTitle: ''
        },
        titleRules: {
          viewTitle: { required: true, message: `${this.$t('view.nameTips')}` }
        },
        select_field: {},
        xName: '',
        xField: '',
        yConfigList: [{
          name: '',
          field: ''
        }],
        seriesBtnText: this.$t('view.addSeries'),
        isSeries: false,
        series: '',
        primaryData: null,
        chartInstance: null,
        legendList: []
      }
    },
    components: {
      chartBase
    },
    methods: {
      setHistory () {
        const historyMap = {
          'Area': this.$t('view.chartArea'),
          'Line': this.$t('view.chartLine'),
          'Histogram': this.$t('view.chartHistogram'),
          'Pie': this.$t('view.chartPie'),
          'Table': this.$t('view.tableTable')
        }
        this.history = []
        this.history.push(
          { name: this.$t('view.config') },
          {
            name: `${this.$t('view.selectChart')}（${historyMap[this.$route.query.type]}）`,
            path: '/home/view/viewChartSelect'
          }
        )
        this.history.push({
          name: `${this.$t('view.selectDataSource')}`,
          path: `/home/view/viewDataSelect?type=${this.$route.query.type}`
        })
        this.history.push({
          name: this.$t('view.dataConfigView')
        })
      },
      getChartData () {
        if (this.$route.query.group === 'others') {
          this.getOthersData()
        } else {
          this.getDefaultField()
        }
      },
      getOthersData () {
        ViewBiz.getSourceData({
          id: this.$route.query.dId
        }).then((data) => {
          if (data.resultCode && data.resultCode !== '00000000') {
            this.$message({
              message: `${this.$t('view.dataSourceError')}: ${data.resultDesc}`,
              type: 'error'
            })
          } else {
            this.primaryData = data
            this.setFields(data)
          }
        })
      },
      getViewDataById () {
        ViewBiz.findViewById({ id: this.$route.query.viewId }).then(data => {
          this.isSeries = data.extend.isSeries
          seriesColor = data.extend.colorList
          if (this.isSeries) this.series = data.param.series
          this.titleForm.viewTitle = data.name
          this.xName = data.param.x.name
          this.xField = data.param.x.field
          this.yConfigList = data.param.y
          if (this.$route.query.group !== 'others') {
            this.getDefaultData(this.isSeries, this.series.split('.')[1], true)
          } else {
            this.run()
          }
        })
      },
      getDefaultField () {
        ViewBiz.getAllKpiField().then(data => {
          this.setFields(data)
        })
      },
      getDefaultData (isSeries = false, groupField, init = false) {
        let requestData = {
          appName: this.$route.query.appName,
          group: this.$route.query.group,
          kpiKey: this.$route.query.kpiKey,
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: new Date().getTime(),
          siteCode: this.$route.query.siteCode
        }
        if (isSeries) requestData.groupField = groupField
        ITDeviceMonitorBiz.getAllChartData(requestData).then(data => {
          this.primaryData = data
          if (this.$route.query.viewId && init) this.run()
        })
      },
      setFields (data) {
        filterData.filterData(data)
        let filterDatas = filterData.getFilterObj()
        let fieldObj = {}
        Object.keys(filterDatas).map((item) => {
          if (filterDatas[item].indexOf('.') !== -1) {
            fieldObj[filterDatas[item]] = filterDatas[item]
          }
        })
        this.select_field = { ...fieldObj }
        this.xField = Object.keys(this.select_field)[0]
        this.yConfigList[0].field = Object.keys(this.select_field)[0]
        if (this.$route.query.viewId) {
          this.getViewDataById()
        } else if (this.$route.query.group !== 'others') {
          this.getDefaultData()
        }
      },
      saveView () {
        this.$refs['titleForm'].validate((valid) => {
          if (valid) {
            let saveObj = {
              type: this.$route.query.type,
              extend: {
                group: this.$route.query.group,
                isSeries: this.isSeries,
                colorList: seriesColor
              },
              name: this.titleForm.viewTitle
            }
            saveObj.param = this.translateJSON()
            if (this.$route.query.group !== 'others') {
              saveObj.extend.appName = this.$route.query.appName
              saveObj.extend.kpiKey = this.$route.query.kpiKey
            }
            if (this.$route.query.viewId) saveObj.id = this.$route.query.viewId
            if (this.$route.query.dId) saveObj.sourceId = this.$route.query.dId
            if (this.$route.query.siteCode) saveObj.extend.siteCode = this.$route.query.siteCode
            ViewBiz.saveView(saveObj).then(data => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({
                name: 'view'
              })
            })
          } else {
            return false
          }
        })
      },
      translateJSON () {
        let fieldObj = {
          x: {
            name: this.xName,
            field: this.xField
          },
          y: []
        }
        if (this.isSeries) fieldObj.series = this.series
        this.yConfigList.map(item => {
          fieldObj['y'].push(item)
        })
        return JSON.stringify(fieldObj)
      },
      run () {
        this.$refs['titleForm'].validate((valid) => {
          if (valid) {
            let timeList = []
            let dataList = []
            let nameList = []
            filterData.filterDataByName(this.primaryData, this.xField)
            let times = this.isSeries ? filterData.getFilterDataList()[0] : filterData.getFilterDataList()
            if (times && times.length > 0) {
              times.map(item => {
                timeList.push(isNaN(Number(item)) ? item : TimeFormat.getFormatTime(item))
              })
            }
            if (this.isSeries) {
              filterData.filterDataByName(this.primaryData, this.yConfigList[0].field)
              if (filterData.getFilterDataList() && filterData.getFilterDataList().length > 0) {
                dataList = filterData.getFilterDataList()
              }
            } else {
              this.yConfigList.map(item => {
                filterData.filterDataByName(this.primaryData, item.field)
                dataList.push(filterData.getFilterDataList())
                nameList.push(item.name ? item.name : '')
              })
            }
            this.drawChart(timeList, dataList, nameList)
          } else {
            return false
          }
        })
      },
      addYfield () {
        this.yConfigList.push({
          name: '',
          field: Object.keys(this.select_field)[0]
        })
      },
      deleteYfield (index) {
        this.yConfigList.splice(index, 1)
      },
      addSeries () {
        this.resetColor()
        this.isSeries = !this.isSeries
        this.series = Object.keys(this.select_field)[0]
        this.yConfigList = [{
          name: '',
          field: Object.keys(this.select_field)[0]
        }]
        if (this.isSeries) {
          let series = this.series.indexOf('.') > -1 ? this.series.split('.')[1] : ''
          this.getDefaultData(true, series)
        } else {
          this.getDefaultData()
        }
      },
      changeSeries (val) {
        let series = val.key.indexOf('.') > -1 ? val.key.split('.')[1] : ''
        this.getDefaultData(true, series)
      },
      initChart () {
        this.chartInstance = echarts.init(document.getElementById('viewChart'))
      },
      setAreaStyle (index) {
        return {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: seriesColor[index]
            }, {
              offset: 1, color: '#fff'
            }]
          }
        }
      },
      drawChart (timeList, dataList, nameList) {
        CHART_OPTION.color = seriesColor
        CHART_OPTION.grid.top = this.isSeries ? '18%' : '10%'
        CHART_OPTION.title.text = this.titleForm.viewTitle
        CHART_OPTION.xAxis.data = timeList
        CHART_OPTION.xAxis.name = this.xName
        CHART_OPTION.grid.bottom = this.xName ? '6%' : '2%'
        CHART_OPTION.series = []
        this.legendList = []
        if (this.isSeries) {
          filterData.filterDataByName(this.primaryData, this.series)
          filterData.getFilterDataList().map((item, index) => {
            this.legendList.push({
              text: item,
              color: seriesColor[index]
            })
          })
        }
        dataList.map((item, index) => {
          CHART_OPTION.series.push({
            data: item,
            type: 'line',
            name: this.isSeries ? this.legendList[index].text : nameList[index],
            areaStyle: this.$route.query.type === 'Area' ? { normal: this.setAreaStyle(index) } : {}
          })
        })
        this.chartInstance.clear()
        this.chartInstance.setOption(CHART_OPTION)
        this.chartInstance.resize()
      },
      changeColor (item, index) {
        seriesColor[index] = item.color
        this.run()
      },
      resize () {
        if (this.chartInstance && !this.chartInstance.isDisposed()) {
          this.chartInstance.resize()
        }
      },
      setChartStyle () {
        const styleObj = {
          width: document.getElementsByClassName('tabView')[0].clientWidth - 354 - 32 + 'px',
          height: document.getElementsByClassName('tabView')[0].clientHeight - 32 - 74 + 'px'
        }
        this.cardStyle.height = styleObj.height
        this.chartStyle = { ...styleObj }
      },
      resetColor () {
        seriesColor = [
          '#0B8DE5',
          '#43CD80',
          '#40E0D0',
          '#FFEC8B',
          '#FFA07A',
          '#FF69B4',
          '#FF0000',
          '#CDC9C9',
          '#DEB887',
          '#AB82FF',
          '#B8860B',
          '#87CEEB',
          '#8FBC8F',
          '#B4EEB4',
          '#CD5B45',
          '#F08080'
        ]
      },
      resetData () {
        this.titleForm.viewTitle = ''
        this.xName = ''
        this.xField = ''
        this.yConfigList = [{
          name: '',
          field: ''
        }]
        this.legendList = []
        this.seriesBtnText = this.$t('view.addSeries')
        this.isSeries = false
        this.series = ''
        this.resetColor()
        this.$nextTick(() => {
          this.$refs.titleForm.clearValidate()
        })
      },
      setResize () {
        eventCenter.addResizeEvent('viewConfig', () => {
          this.setChartStyle()
          this.$nextTick(() => {
            this.resize()
          })
        })
      }
    },
    watch: {
      isSeries (val) {
        this.seriesBtnText = val ? this.$t('view.closeSeries') : this.$t('view.addSeries')
      },
      $route (to, from) {
        if (to.name === 'viewConfig') {
          if (from.name === 'viewDataSelect') {
            this.resetData()
            this.setHistory()
            this.getChartData()
            if (this.chartInstance) this.chartInstance.clear()
          }
          if (from.name === 'view') {
            this.getChartData()
          }
          this.setResize()
        } else if (from.name === 'viewConfig') {
          eventCenter.removeResizeEvent('viewConfig')
        }
      }
    },
    mounted () {
      this.setHistory()
      this.getChartData()
      this.setChartStyle()
      this.setResize()
      this.initChart()
    }
  }
</script>

<style scoped>
  .card-wrap {
    width: 356px;
    min-width: 356px;
  }
  .view-config--form-title {
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.65);
  }
  .view-config--form__close {
    position: absolute;
    z-index: 9;
    top: 10px;
    right: 0px;
    font-size: 16px;
    width: 20px;
    cursor: pointer;
    text-align: center;
    color: rgba(0,0,0,0.45);
  }
  .view-config--form__close:hover {
    color: #FF4949;
  }
  .chart-wrap {
    position: relative;
  }
  .ip-wrap {
    position: absolute;
    top: 26px;
    left: 14px;
    z-index: 9;
  }
  .color-wrap {
    display: flex;
    align-items: center;
  }
</style>